import {
  AgChartPanel as SharedAgChartPanel,
  buildAgOptions,
  type ChartDataset,
  type ChartType,
} from "@/components/cinch/charts";

/**
 * Charts Lab adapter over the shared {@link SharedAgChartPanel}: takes a lab
 * dataset + chart type, builds brand-themed options, and renders them. The
 * reusable panel (options-in) lives in `@/components/cinch/charts`.
 */
export function AgChartPanel({
  dataset,
  chartType,
  isDark,
}: {
  dataset: ChartDataset;
  chartType: ChartType;
  isDark: boolean;
}) {
  return <SharedAgChartPanel options={buildAgOptions(dataset, chartType, isDark)} />;
}
